import React, { useEffect, useState } from "react";
import Plantilla from "../../components/plantilla";
import FormDetalle from "./components/FormDetalle";
import FormTarjeta from "./components/FormTarjeta";
import { notificacionPagoFactura } from "../../services/ParserService";
import { usePageReducer } from "../../hooks/usePageReducer";
import Modal from "./components/Modal";
import LoadingModal from "./components/ModalLoading";
import { consultarPolizaBalance } from "../../services/PagoService";
import { usePagoAuth } from "../../context/PagoAuthContext";
import PaginaInformacion from "./components/PaginaInformacion";
import { CONSTANT, PRODUCT_TYPES, MENSAJES } from "../../utils/Constants";
import { getCalculateDate } from "../../utils/AppUtils";

/**
 * Normaliza la respuesta del API de balance (pagoservice polizas/{numeroPoliza}/balance)
 * al formato que usan los componentes (codigoRespuesta, totalPagar, pagoMinimo, numeroReferencia, etc.).
 */
function normalizeBalanceResponse(apiBody) {
  if (!apiBody) {
    return { codigoRespuesta: 0, totalPagar: 0, pagoMinimo: 0, numeroReferencia: "" };
  }
  const meta = apiBody.meta || {};
  if (meta.codigo !== 200 && meta.codigo !== undefined) {
    return {
      codigoRespuesta: meta.codigo,
      RestError: { errorMessage: meta.descripcion || "Error al consultar balance" },
    };
  }
  const d = apiBody.data || {};
  const dop = d.montos?.dop || {};
  const usd = d.montos?.usd;
  return {
    codigoRespuesta: 0,
    totalPagar: dop.total ?? 0,
    pagoMinimo: dop.pagoMinimo ?? 0,
    numeroReferencia: d.numeroReferencia ?? "",
    moneda: d.moneda,
    montosMonedaOriginal: usd != null ? { totalPagar: usd.total ?? 0 } : undefined,
  };
}

const Home = (props) => {
  const { accessToken, error: pagoAuthError, loading: pagoAuthLoading } = usePagoAuth();
  const [{ loader }, dispatch] = usePageReducer();
  const [datosFacturacion, setDatosFacturacion] = useState(null);
  const [modal, setModal] = useState({ isVisible: false, component: null });
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [balancePoliza, setBalancePoliza] = useState({});
  const [esPolizaValida, setEsPolizaValida] = useState({});

  const mostrarModal = (
    titulo,
    mensaje,
    modalType,
    comprobante,
    autorizacion
  ) => {
    const hideModal = () => {
      setModal({ isVisible: false, component: null });
    };

    setModal({
      isVisible: true,
      component: (
        <Modal
          cuerpo={mensaje}
          recibo={comprobante}
          autorizacion={autorizacion}
          onCancel={hideModal}
          titulo={titulo}
          modalType={modalType}
        />
      ),
    });
  };

  useEffect(() => {
    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    let token = props.location.pathname.replace("/", "");

    if (token === "" || pagoAuthLoading) {
      return;
    }

    if (datosFacturacion === null) {

      let request = `?where={"data.enlaceDePago.id":"${token}"}`;

      notificacionPagoFactura(request, PRODUCT_TYPES.GENERIC).then((response) => {
        if (response.results.length > 0) {
          setDatosFacturacion(response.results[0]);
        }

        const numeroPoliza = response.results[0]?.data?.poliza;
        const factura = response.results[0]?.data?.factura;
        if (!numeroPoliza || !accessToken) {
          if (!accessToken && !pagoAuthLoading) {
            setEsPolizaValida({ errorMessage: pagoAuthError || "No se pudo conectar con el servicio de pago." });
          }
          dispatch({ type: "LOADED" });
          return;
        }

        consultarPolizaBalance(numeroPoliza, accessToken, factura).then((result) => {
          const normalized = normalizeBalanceResponse(result.data);
          if (typeof normalized.RestError !== "undefined") {
            setEsPolizaValida(normalized.RestError);
            dispatch({ type: "LOADED" });
            return;
          }
          if (normalized.codigoRespuesta !== 0 && normalized.totalPagar === 0) {
            setBalancePoliza(normalized);
            dispatch({ type: "LOADED" });
            return;
          }
          setBalancePoliza(normalized);
          dispatch({ type: "LOADED" });
        });
      });
    }
  }, [datosFacturacion, dispatch, props.location.pathname, balancePoliza, accessToken, pagoAuthLoading, pagoAuthError]);

  if (datosFacturacion != null) {
    if (getCalculateDate(datosFacturacion.createdAt) >= 1.5) {
      return (
        <Plantilla loader={loader}>
          <PaginaInformacion type='errorInfo' tittle={MENSAJES.LINK_CADUCADO.TITULO} message={MENSAJES.LINK_CADUCADO.DESCRIPCION} />
        </Plantilla>
      );
    }
  }

  if (balancePoliza.totalPagar === 0) {
    return (
      <Plantilla loader={loader}>
        <PaginaInformacion type='exclamation' tittle={MENSAJES.BALANCE_POLIZA.TITULO} message={MENSAJES.BALANCE_POLIZA.DESCRIPCION} />
      </Plantilla>
    );
  }

  if (Object.keys(esPolizaValida).length > 0) {
    return <Plantilla loader={loader}>
      <PaginaInformacion type='exclamation' tittle={MENSAJES.POLIZA.TITULO} message={esPolizaValida.errorMessage} />
    </Plantilla>
  }

  return (
    <Plantilla loader={loader} modal={modal}>
      {/* <label>Hola home</label> */}
      {datosFacturacion && (
        <FormDetalle
          datos={datosFacturacion}
          mostrarModal={mostrarModal}
          balancePoliza={balancePoliza}
        />
      )}
      <FormTarjeta
        setModal={setModal}
        datosFacturacion={datosFacturacion}
        setIsLoadingModal={setIsLoadingModal}
        balancePoliza={balancePoliza}
      />
      {isLoadingModal && <LoadingModal />}
    </Plantilla>
  );
};

export default Home;
